import { useEffect } from 'react'
import PageLayout from '../../common/components/PageLayout/PageLayout'
import './Attributions.css'

function Attributions () {
  useEffect(() => {
    const handleMessage = (e: MessageEvent<any>) => {
      const { type, data } = JSON.parse(e.data)
      if (type === 'igem-attribution-form') {
        const element = document.getElementById('igem-attribution-form')
        if (element) {
          element.style.height = data + 50 + 'px'
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <PageLayout title="Attributions">
      <div className="row mt-4">
        <iframe
          style={{ width: '100%', border: 'none' }}
          id="igem-attribution-form"
          src="https://attributions.igem.org?team=ULaval&year=2023"
        />
      </div>
    </PageLayout>
  )
}

export default Attributions
